import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Navbar from "../../components/Navbar";
import Footer from "../../components/footerAccessibilityPageFooter";
import pswimg from "../../assets/images/psw-flow1.svg";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  Image,
  Button,
  Spinner,
} from "react-bootstrap";
import "../../styles/Forgetpsw.css";
import {
  existingUserOrNot,
  Forget_Passwords,
  Forget_Passwords_Employer,
} from "../../helpers/backendHelper";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("please enter a valid email"),
    }),
    onSubmit: async (values) => {
      try {
        const existingUser = await existingUserOrNot({ email: values.email });

        if (
          existingUser.statusCode === 200 &&
          existingUser.userType === "JobSeeker"
        ) {
          setLoading(true);
          const response = await Forget_Passwords({ email: values.email });
          if (response) {
            navigate("/forgetpassword/otp", { state: { email: values.email } });
            console.log("Email sent to: " + values.email);
          }
        } else if (
          existingUser.statusCode === 200 &&
          existingUser.userType === "Employer"
        ) {
          setLoading(true);
          const response = await Forget_Passwords_Employer({
            email: values.email,
          });
          if (response) {
            navigate("/forgetpassword/otp", { state: { email: values.email } });
            console.log("Email sent to: " + values.email);
          }
        } else if (
          existingUser.statusCode === 404 &&
          existingUser.isExistingUser === false
        ) {
          alert("User Not found !");
        }
      } catch (error) {
        console.error("Failed to send email", error);
        alert("Failed to send email. Please try again later.");
      }
    },
  });

  return (
    <Container fluid className="p-0 pswd d-flex flex-column min-vh-100">
      <Navbar />
      <div className="flex-grow-1 d-flex justify-content-center align-items-center container p-0">
        <Row className="w-100 pswd-row d-flex justify-content-between align-items-center m-0">
          <Col md={6} lg={5}>
            <Card className="pswd-content">
              <h4 className="fw-bold">Forget Password?</h4>
              <p className="p-title">
                Enter the email address associated with your account
              </p>
              <form onSubmit={formik.handleSubmit}>
                <input
                  type="email"
                  name="email"
                  placeholder="@Enter your Email address"
                  className={`form-control mt-3 mb-1 py-2 input-height ${
                    formik.touched.email && formik.errors.email
                      ? "is-invalid"
                      : ""
                  }`}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="invalid-feedback">{formik.errors.email}</div>
                ) : null}
                <Link to="/tryanotherway" className="text-dark">
                  <p className="text-decoration-underline fw-bolder mt-3">
                    Try another way!
                  </p>
                </Link>
                {/* <button type="submit" className="btn btn-color-primary input-height w-100 py-2 mt-3 ms-0" >
                        <strong>Continue</strong>
                    </button> */}
                <Button
                  type="submit"
                  className="btn btn-color-primary input-height w-100 py-2 mt-3 ms-0"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner
                        className="me-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      <span>Loading...</span>
                    </>
                  ) : (
                    <strong>Continue</strong>
                  )}
                </Button>
              </form>
            </Card>
          </Col>
          <Col md={5} className="d-none d-md-block">
            <Image className="pswd-img" src={pswimg} alt="img" fluid />
          </Col>
        </Row>
      </div>
      <Footer className="mt-auto" />
    </Container>
  );
};

export default ForgetPassword;
